import { ListTextArea } from 'Components'
import { ICreateJobForm } from '@/Models'
import { useFormContext } from 'react-hook-form'
import * as yup from 'yup'

export const strReq = 'Field must be a string'
export const numReq = 'Field must be a number'
export const reqField = 'Field is required'
export const minFieldReq = 'Accepted range for field is 1 to 5'

export const createJobStepTwoSchema = yup.object().shape({
  aboutRole: yup.string().required(reqField),
  responsibility: yup.string().required(reqField),
  requirement: yup.string().required(reqField),
  aboutTradegrid: yup.string().required(reqField),
})

export const CreateJobStepTwoComp = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ICreateJobForm>()

  return (
    <div className='form-ste form-two deselect'>
      <div className='containe'>
        <div className='form-group step-two row justify-content-cente'>
          <div className='mb-3 text-start col-12 mt-2'>
            <label className='label-step-two'>About the Role</label>
            <textarea className='form-control' {...register('aboutRole')} />
            {errors.aboutRole && <p className='text-danger'>{errors.aboutRole.message}</p>}
          </div>
        </div>
        <div className='form-group step-two row justify-content-cente'>
          <div className='mb-3 text-start col-12 mt-2'>
            <label className='label-step-two'>Responsibilities</label>
            <ListTextArea
              {...register('responsibility')}
              showBullets
              error={errors.responsibility?.message}
            />
          </div>
        </div>
        <div className='form-group step-two row justify-content-cente'>
          <div className='mb-3 text-start col-12 mt-2'>
            <label className='label-step-two'>Requirement</label>
            <ListTextArea
              {...register('requirement')}
              showBullets
              error={errors.requirement?.message}
            />
          </div>
        </div>
        <div className='form-group step-two row justify-content-cente'>
          <div className='mb-3 text-start col-12 mt-2'>
            <label className='label-step-two'>Skill</label>
            <ListTextArea
              {...register('requirement')}
              showBullets
              error={errors.skills?.message}
            />
          </div>
        </div>
        <div className='form-group step-two row justify-content-cente'>
          <div className='mb-3 text-start col-12 mt-2'>
            <label className='label-step-two'>About TradeGrid</label>
            <textarea className='form-control' {...register('aboutTradegrid')} />
            {errors.aboutTradegrid && (
              <p className='text-danger'>{errors.aboutTradegrid.message}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
